<button (click)="updateTableData()">Update table data</button>
<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
  (sort)="onSort($event)"
></aur-mat-table>
